import React, { useCallback, memo } from 'react';
import { Select } from '@leasequery/lq.react-component-library';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import { REPORT_CURRENCY_SELECT_OPTIONS } from '../../../constants';
import { ReportCurrency, ClientCustomCalendarModel } from '../../../models';
import * as Styled from './styled';
import { ReportTypeSetting } from '../../../models/reportTypeSetting';
import { Icon } from '../../../components';
import { CurrencySelectorWrapper } from '../../../components';

interface ReportSettingWeightedAverageProps {
  onChange: (updatedValue: ReportSettingWeightedAverageState) => void;
  reportSettingState: ReportSettingWeightedAverageState;
  reportTypeSetting: ReportTypeSetting;
  isAllowPIT: boolean;
  customCalendarSettings?: ClientCustomCalendarModel;
}

export interface ReportSettingWeightedAverageState {
  selectedCurrency: SelectOption<ReportCurrency>;
  asOf: string;
  isRunByTransitionDate: boolean;
  isValid: boolean;
}

function ReportSettingWeightedAverage({
  onChange,
  reportSettingState,
}: ReportSettingWeightedAverageProps): JSX.Element {
  return (
    <>
      <CurrencySelectorWrapper>
        <Styled.DropdownBar>
          <div>
            <Icon name="currency" />
          </div>
          <Select
            placeholder="Local currency"
            label="Currency"
            name="currency"
            options={REPORT_CURRENCY_SELECT_OPTIONS}
            onChange={useCallback(
              (option: SelectOption<ReportCurrency>): void => {
                onChange({
                  ...reportSettingState,
                  selectedCurrency: option,
                });
              },
              [onChange, reportSettingState],
            )}
            value={reportSettingState.selectedCurrency}
          />
        </Styled.DropdownBar>
      </CurrencySelectorWrapper>
      <Styled.Line />
    </>
  );
}

export default memo(ReportSettingWeightedAverage);
